export const RESCHEDULE_DIRECT_MIXPANEL_EVENTS = {
  ViewedRescheduleDirect: 'Viewed Reschedule Direct',
  ViewedRescheduleDirectExpired: 'Viewed Reschedule Direct Expired',
  ViewedRescheduleDirectConfirmation: 'Viewed Reschedule Direct Confirmation',

  PickedRescheduleDirectDate: 'Picked Reschedule Direct Date',
  PickedRescheduleDirectTherapist: 'Picked Reschedule Direct Therapist',
  ConfirmedRescheduleDirect: 'Confirmed Reschedule Direct',
  RescheduledDifferentTherapist: 'Rescheduled Different Therapist',
};
